<template>
    <div id="new_station" class="ui segment">
        <h1 class="ui header">{{ station.name }}</h1>
        <div v-if="is_initialized">
            <form class="ui form">
                <div class="field">
                    <label>{{ $t('models.attributes.stations.name') }}</label>
                    <input type="text" v-model="station.name">
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.stations.code') }}</label>
                    <input type="text" v-model="station.code">
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.stations.address') }}</label>
                    <input type="text" v-model="station.address">
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.stations.phone') }}</label>
                    <input type="text" v-model="station.phone">
                </div>
                <div class="field">
                    <label>母站點</label>
                    <select v-model="station.parent_station_identity">
                        <option v-for="parent_station in parent_stations" :key="parent_station.identity" :value="parent_station.identity">{{ parent_station.name }}</option>
                    </select>
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.stations.note') }}</label>
                    <textarea type="text" v-model="station.note"></textarea>
                </div>
                <button class="ui basic positive button" @click.prevent="create_station">{{ $t('ui.general.create') }}</button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "NewStation",
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            station: {},
            errors: [],
        }
    },
    created() {
        this.init()
    },
    mounted() {
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "new_station") {
                this.init()
            }
        },
    },
    computed: {
        current_store() {
            return this.$store.state.provider.stations_module
        },
        stations() {
            return this.current_store.stations
        },
        parent_stations() {
            return _.filter(this.stations, e => {
                return !e.parent_station
            })
        },
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                this.is_processing = false
                this.station = {
                    name: this.$t('ui.page_titles.new_station'),
                    address: this.$t('models.attributes.stations.address'),
                    phone: this.$t('models.attributes.stations.phone'),
                    code: this.$t('models.attributes.stations.code'),
                    note: this.$t('models.attributes.stations.note'),
                    parent_station_identity: null
                }
                this.errors = []
                resolve()
            })
            if (!this.stations) {
                await this.$store.dispatch('provider/stations_module/fetch_stations');
            }
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        create_station() {
            this.is_processing = true
            this.errors = []
            var params = this.station
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_stations_create).parse(
                {},
                ""
            )

            return axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }}).then(response => {
                if (response.data.status == "success") {
                    this.is_processing = false
                    // this.$noty.success("建立站點成功")
                    this.$noty.success(
                        this.$t('ui.notifications.success.create__name', {
                            name: this.$t('models.stations')
                        })
                    )
                    this.$store.dispatch('provider/fetch_stations')
                    this.$router.push({ name: 'stations' })
                } else {
                    // this.$noty.error("建立站點失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.create__name', {
                            name: this.$t('models.stations')
                        })
                    )
                    this.is_processing = false
                }
            })
            .catch(error => {
                // this.$noty.error("建立站點失敗")
                this.$noty.error(
                    this.$t('ui.notifications.error.create__name', {
                        name: this.$t('models.stations')
                    })
                )
                this.is_processing = false
            })
        },
    },
    components: {
    }
}
</script>

<style scoped>
</style>
